import router from "next/router";
import APIService, { Params } from "./api_service";

const DEEPSEARCH_AUTH_KEY =
  "Basic Mzc2YmRlZmY2YTVlNGE1NjgzOGNjNTYzM2ZiYzZiMjI6MWQ3ZjIyMTVjYjY4MTc0MjdlY2ExM2ZkNTQ0ODRhNDkyMmZiYmNiZTRjYzk1YjFlNDc3Y2Q1NGI2Mzc0OGFiZA==";

const LOCALE_MAPPER: { [key: string]: string } = {
  ko: "ko_KR",
  en: "en_US",
};
export class _ComputeApiService extends APIService {
  constructor(url: string) {
    super(url + "/v1/compute", {
      Authorization: DEEPSEARCH_AUTH_KEY,
      "X-DeepSearch-App-ID": "deepsearch",
    });
  }

  get(params?: Params | any, options?: Params | any) {
    const param = {
      ...params,
      locale: LOCALE_MAPPER[router?.locale ?? "ko"],
    };
    return super.get(param, options);
  }
}
const ComputeApiService = new _ComputeApiService(
  typeof window !== "undefined"
    ? window?.__RUNTIME_CONFIG__?.API_URL ?? "https://alpha-api.deepsearch.com"
    : "https://alpha-api.deepsearch.com"
);

export default ComputeApiService;
